// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__C8f66","footer":"Form_footer__2hDRl"};